export default [
    {
        path: '/shipment-carrier-summary/list',
        name: 'shipment_carrier_summary_list',
        component: () => import('@src/shipment-carrier-summary/document-list'),
        meta: {
            title: 'Tagesabschluss Versand',
            role: 'ROLE_LIST_SHIPMENT_CARRIER_SUMMARY_DOCUMENT',
        },
    },
];
